<template>
  <div class="content-container flex-column">
    <div class="grid-x toolbar fixed">
      <div class="cell auto">
        <h4 class="no-margin toolbar-title">Innstillinger - {{name}}</h4>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormSubmittable">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" @click="handleSubmit()" class="button primary">Lagre endringer</a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormProcessing">
        <a href="javascript:;" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary loading">Lagrer...<span class="loader-spinner"></span></a>
      </div>

      <div class="cell shrink" v-if="$store.getters.isFormLoading">
        <a href="javascript:;" @click="onCancel()" class="button primary transparent">Lukk redigering</a>
        <a href="javascript:;" class="button primary" disabled>Lagre<span class="show-for-medium"> endringer</span></a>
      </div>
    </div>

    <TheLoader :active="$store.getters.isFormLoading"/>
    <div v-if="!$store.getters.isFormLoading" class="content-container flex-row">
      <section class="content large-padding fixed-width small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Kategori id" v-model.trim="item.Kategoriid" :disabled="true"/>
              <TheTextInput containerClassName="cell large-6" label="Kategori kode" name="Kategori" :disabled="edit" v-model.trim="item.Kategori" maxlength="10" required v-validate="'required|max:10'"/>

              <TheSelectInput containerClassName="cell large-12" label="Avdeling" name="Avdelingsid" required v-validate="'required'" v-model="item.Avdelingsid" :items="avdelingsOptions"/>
              <TheSelectInput containerClassName="cell large-12" label="Expertavdeling" name="Expertavdelingsid" required v-validate="'required'" v-model="item.Expertavdelingsid" :items="expertAvdelingsOptions"/>

              <!--
              <div class="cell large-12">
                <div class="input-container" :class="{'form-error': errors.has('expavd')}">
                  <label>Ekspertavdeling *</label>
                  <input type="hidden" name="expavd" v-model.trim="hasSelectedExpadv" v-validate="'max:4'">
                  <span class="form-error-label" style="text-align: left; position: initial;" v-if="errors.has('expavd')">
                    Velg minst en ekspertavdeling
                  </span>

                  <ul class="checkbox-list">
                    <li v-if="expertAvdelingsStatus !== ''">
                      <div class="input-container"><label>{{expertAvdelingsStatus}}</label></div>
                    </li>

                    <li v-else v-for="option in expertAvdelingsOptions" v-bind:key="option.key">
                      <div class="input-container checkbox">
                        <input type="radio" :id="option.key" :key="option.key" :value="option.key" v-model="expertAvdelingsChoosen">
                        <label :for="option.key">{{option.val}}</label>
                        <span class="glyph"><svg viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              -->
            </div>

            <div class="grid-x grid-padding-x">
              <TheTextInput containerClassName="cell large-6" label="Beskrivelse" name="Beskrivelse" v-model.trim="item.Beskrivelse" maxlength="100" v-validate="'max:100'"/>
              <TheTextInput containerClassName="cell large-6" label="Engelsk" name="Engelsk" v-model.trim="item.Engelsk" maxlength="100" v-validate="'max:100'"/>

              <TheDecimalInput containerClassName="cell large-4" label="Kunstavgift" name="Kunstneravgift" v-model.trim="item.Kunstneravgift" maxlength="10" v-validate="'decimal'"/>
              <TheDecimalInput containerClassName="cell large-4" label="Salar" name="Salar" v-model.trim="item.Salar" maxlength="13" v-validate="'decimal'"/>
              <TheSelectInput containerClassName="cell large-4" label="Mva" name="Mvaid" v-model.trim="item.Mvaid" :items="mvaOptions"/>

              <TheDecimalInput containerClassName="cell large-3" label="Salar1" name="Salar1" v-model.trim="item.Salar1" maxlength="10" v-validate="'decimal'"/>
              <TheDecimalInput containerClassName="cell large-3" label="Salar2" name="Salar2" v-model.trim="item.Salar2" maxlength="10" v-validate="'decimal'"/>
              <TheDecimalInput containerClassName="cell large-3" label="Belop1" name="Belop1" v-model.trim="item.Belop1" maxlength="10" v-validate="'decimal'"/>
              <TheDecimalInput containerClassName="cell large-3" label="Belop2" name="Belop2" v-model.trim="item.Belop2" maxlength="10" v-validate="'decimal'"/>

              <TheTextInput containerClassName="cell large-12" label="Info" name="Info" v-model.trim="item.Info" maxlength="1000" v-validate="'max:1000'"/>
            </div>
            <div class="grid-x grid-padding-x">
              <div class="cell auto">
                <div class="input-container">
                  <label>Twentyfourseven</label>
                  <span class="avatar name right green" v-if="item.twentyfourseven_category_id">Ja <span class="name">Synkronisert med 247</span></span>
                  <span class="avatar name right red" v-else>Nei <span class="name">Ikke synkronisert med 247</span></span>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import InstillingerService from '@/services/InstillingerService'
// import MiscService from '@/services/MiscService'
import axios from 'axios'

export default {
  name: 'InstillingerKategoriEdit',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    servicename: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      service: InstillingerService(this.servicename),
      edit: false,
      item: {},
      mvaOptions: [],
      avdelingsOptions: [],
      expList: [],
      loading: true
    }
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    // Edit mode
    this.edit = !!this.$route.params.id

    // Load
    this.fetch()
  },
  watch: {
    'item.Avdelingsid': function (newVal, oldVal) {
      // Reset expertavdelings id
      if (oldVal !== undefined && parseInt(newVal) !== parseInt(oldVal)) {
        this.item.Expertavdelingsid = null
      }
    }
  },
  computed: {
    expertAvdelingsOptions: function () {
      let retval = []

      if (!this.hasAvdeling) {
        retval.unshift({key: null, val: 'Velg avdeling først'})
      } else {
        retval = this.expList.filter((i) => {
          return parseInt(i.Avdelingsid) === parseInt(this.item.Avdelingsid)
        })

        if (retval.length < 1) {
          retval.unshift({key: null, val: 'Ingen ekspertavdeling'})
        } else {
          retval.unshift({key: null, val: 'Velg ekspertavdeling', disabled: true})
        }
      }

      return retval
    },
    hasAvdeling: function () {
      return !(this.item.Avdelingsid === null || this.item.Avdelingsid === '' || this.item.Avdelingsid < 0)
    }
  },
  methods: {
    fetch: function () {
      this.mvaOptions.unshift({key: this.item.Mvaid, val: 'Laster...'})
      this.avdelingsOptions.unshift({key: this.item.Avdelingsid, val: 'Laster...'})

      this.loadDropdowns()
        .then((response) => {
          this.mvaOptions = response.mva
          this.mvaOptions.unshift({key: null, val: 'Velg mva'})

          this.avdelingsOptions = response.avdeling
          this.avdelingsOptions.unshift({key: null, val: 'Velg avdeling', disabled: true})

          this.expList = response.expertavdeling
          this.expList.unshift({key: null, val: 'Velg ekspertavdeling', disabled: true})

          if (!this.edit) {
            this.setFormLoading(false)
          } else {
            this.service.view(this.$route.params.id)
              .then((response) => {
                this.item = response.data
                // if (this.item.expertavdeling && this.item.expertavdeling.length > 0) {
                //   this.item.expertavdeling.forEach((i) => {
                //     this.expertAvdelingsChoosen.push(i.id)
                //   })
                // }
              })
              .catch(() => {
                this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn vare')

                this.onCancel()
              })
              .then(() => {
                this.setFormLoading(false)
              })
          }
        })
    },
    loadDropdowns: function () {
      return new Promise((resolve, reject) => {
        axios
          .all([
            InstillingerService('mva').dropdown('id'),
            InstillingerService('avdeling').dropdown(),
            InstillingerService('expertavdeling').dropdown()
          ])
          .then(
            axios.spread(function (mva, avdeling, expertavdeling) {
              resolve({
                mva: mva.data,
                avdeling: avdeling.data,
                expertavdeling: expertavdeling.data
              })
            })
          )
          .catch(error => {
            reject(error)
          })
      })
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // Force code to be uppercase
            this.item.Varekode = this._.toUpper(this.item.Varekode)

            this.item.expertavdeling_kategori = []
            if (this.item.Expertavdelingsid) {
              this.item.expertavdeling_kategori.push({ Kategori: this.item.Kategori, Expertavdelingsid: this.item.Expertavdelingsid })
            }
            // this.expertAvdelingsChoosen.forEach((i) => {
            //   this.item.expertavdeling_kategori.push({ Kategori: this.item.Kategori, Expertavdelingsid: i })
            // })

            this.service.save(this.item.Kategoriid, this.item)
              .then((response) => {
                this.$helpers.showSuccessAlert('Kategori er lagret')

                this.item = response.data

                if (!this.edit) {
                  this.$router.go(-1)
                }
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                } else {
                  this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen', 'danger')
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    },
    onCancel: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
input[name="Kategori"] {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Instillinger/InstillingerKategoriEdit.vue